var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17C1.45 17 0.979167 16.8042 0.5875 16.4125C0.195833 16.0208 0 15.55 0 15C0 14.45 0.195833 13.9792 0.5875 13.5875C0.979167 13.1958 1.45 13 2 13C2.55 13 3.02083 13.1958 3.4125 13.5875C3.80417 13.9792 4 14.45 4 15C4 15.55 3.80417 16.0208 3.4125 16.4125C3.02083 16.8042 2.55 17 2 17ZM14 17C14 15.05 13.6333 13.2292 12.9 11.5375C12.1667 9.84583 11.1667 8.36667 9.9 7.1C8.63333 5.83333 7.15417 4.83333 5.4625 4.1C3.77083 3.36667 1.95 3 0 3V0C2.36667 0 4.575 0.441667 6.625 1.325C8.675 2.20833 10.475 3.425 12.025 4.975C13.575 6.525 14.7917 8.325 15.675 10.375C16.5583 12.425 17 14.6333 17 17H14ZM8 17C8 15.8833 7.79167 14.8458 7.375 13.8875C6.95833 12.9292 6.38333 12.0833 5.65 11.35C4.91667 10.6167 4.07083 10.0417 3.1125 9.625C2.15417 9.20833 1.11667 9 0 9V6C1.53333 6 2.9625 6.2875 4.2875 6.8625C5.6125 7.4375 6.775 8.225 7.775 9.225C8.775 10.225 9.5625 11.3875 10.1375 12.7125C10.7125 14.0375 11 15.4667 11 17H8Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.f98a1fa57772ecfc5116ba8c9eb56db4.svg";
export { ForwardRef as ReactComponent };